import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
} from '@mui/material';

const FrequentClientsTable = ({ data = [], loading }) => {
  return (
    <Paper elevation={2} sx={{ height: 360, p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography variant="subtitle1" gutterBottom>
        Clientes frecuentes
      </Typography>
      <TableContainer sx={{ overflowY: 'auto', flex: 1 }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: 'background.paper' }}>Cliente</TableCell>
              <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Compras</TableCell>
              <TableCell align="center" sx={{ backgroundColor: 'background.paper' }}>Última compra</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              [...Array(5)].map((_, i) => (
                <TableRow key={i}>
                  <TableCell><Skeleton width="80%" /></TableCell>
                  <TableCell align="center"><Skeleton width="40%" /></TableCell>
                  <TableCell align="center"><Skeleton width="60%" /></TableCell>
                </TableRow>
              ))
            ) : data.length > 0 ? (
              data.map((client, idx) => (
                <TableRow key={idx}>
                  <TableCell>{client.name}</TableCell>
                  <TableCell align="center">{client.purchases}</TableCell>
                  <TableCell align="center">{client.lastPurchase}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  <Typography variant="body2" color="textSecondary">
                    No hay datos disponibles.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default FrequentClientsTable;
